import { Component, Input } from '@angular/core';
import { ApplicationActions } from '../../actions/application.actions';
import { NgRedux } from '@angular-redux/store';
import * as _ from 'lodash';
import { MaskingService } from '../../shared/services/masking.service';

@Component({
  selector: 'md-address',
  template: require('./address.component.html'),
  styles: [require('./address.component.scss')],
})
export class AddressComponent {
  @Input() options;

  constructor(
    appActions: ApplicationActions,
    ngRedux: NgRedux,
    masking: MaskingService
  ) {
    this.appActions = appActions;
    this.ngRedux = ngRedux;
    this.masking = masking;
  }

  ngOnInit() {
    if (this.options.address) {
      let arrayPath;
      const addressObj = this.options.address;
      // eslint-disable-next-line guard-for-in, no-restricted-syntax
      for (const element in addressObj) {
        arrayPath = addressObj[element].inputPath.split('.');
        arrayPath.unshift('applicationStore');
        this.arrayPath = arrayPath;

        if (addressObj[element].inputPath.match(/\[\d+\]/) !== -1) {
          // eslint-disable-next-line max-len
          this.reduxObservable$ = this.ngRedux.select((state) =>
            _.get(state, `applicationStore.${addressObj[element].inputPath}`)
          );
        } else {
          this.reduxObservable$ = this.ngRedux.select(this.arrayPath);
        }

        // Set default value if it exists in schema and state is null
        this.defaultValue = this.options.attr.defaultValue || null;
        this.initialReduxValue = this.appActions.getData(
          addressObj[element].inputPath
        );
        if (!this.initialReduxValue && this.init === false) {
          this.appActions.setData(
            addressObj[element].inputPath,
            this.defaultValue
          );
        }

        this.reduxSubscription = this.reduxObservable$.subscribe((state) => {
          this.currentValue =
            state === null ||
            state === undefined ||
            (state && Object.keys(state).length === 0)
              ? '-'
              : state;

          if (
            (this.currentValue !== null || this.init === true) &&
            this.currentValue !== '-'
          ) {
            this.updateData();
          }

          this.init = true;
        });
      }
    }
  }

  ngOnChanges() {
    this.updateData();
  }

  updateData() {
    if (this.options.address) {
      const addressObj = this.options.address;
      // eslint-disable-next-line guard-for-in, no-restricted-syntax
      for (const element in addressObj) {
        switch (addressObj[element].inputPath) {
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.address.street':
            const street = this.appActions.getData(
              'PersonalInformation.address.street',
              ''
            );
            this.street1 = street;
            break;
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.address.street2':
            const street2 = this.appActions.getData(
              'PersonalInformation.address.street2',
              ''
            );
            this.street2 = street2;
            break;
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.address.city':
            const city = this.appActions.getData(
              'PersonalInformation.address.city',
              ''
            );
            this.city = city;
            break;
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.address.state':
            const state = this.appActions.getData(
              'PersonalInformation.address.state',
              ''
            );
            this.state = state;
            break;
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.address.zip':
            const zip = this.appActions.getData(
              'PersonalInformation.address.zip',
              ''
            );
            this.zip = zip.indexOf('-') === -1 ? zip : zip.substring(0, zip.indexOf('-'));
            break;
          // MAILING
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.mailingAddress.street':
            const mailingStreet = this.appActions.getData(
              'PersonalInformation.mailingAddress.street',
              ''
            );
            this.street1 = mailingStreet;
            break;
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.mailingAddress.street2':
            const mailingStreet2 = this.appActions.getData(
              'PersonalInformation.mailingAddress.street2',
              ''
            );
            this.street2 = mailingStreet2;
            break;
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.mailingAddress.city':
            const mailingCity = this.appActions.getData(
              'PersonalInformation.mailingAddress.city',
              ''
            );
            this.city = mailingCity;
            break;
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.mailingAddress.state':
            const mailingState = this.appActions.getData(
              'PersonalInformation.mailingAddress.state',
              ''
            );
            this.state = mailingState;
            break;
          // eslint-disable-next-line no-case-declarations
          case 'PersonalInformation.mailingAddress.zip':
            const mailingZip = this.appActions.getData(
              'PersonalInformation.mailingAddress.zip',
              ''
            );
            this.zip = mailingZip.indexOf('-') === -1 ? mailingZip : mailingZip.substring(0, mailingZip.indexOf('-'));
            break;
          default:
            this.street1 = this.currentValue;
        }
      }
    }
  }
}
